/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { PostHogProvider } from '@posthog/react';
import App from './App';
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <PostHogProvider
        apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_PROJECT_TOKEN}
        options={{ api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST }}
      >
        <App />
      </PostHogProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
